export function waitForJQuery(callback) {
    if (window["jQuery"] === undefined) {
        window.setTimeout(() => {
            waitForJQuery(callback);
        }, 100);
    }
    else {
        callback();
    }
}
